export const templateNavigationLevels = ["namespace", "category", "name"];
export type TemplateNavigationLevel = (typeof templateNavigationLevels)[number];
export type TemplateNavigationPath = Record<TemplateNavigationLevel, string>;

export const templateTypes = ["template", "macro"];
export type TemplateType = (typeof templateTypes)[number];

export type Version = "draft" | "live" | string;

export interface DraftExists {
  content: boolean;
  config: boolean;
  translations: boolean;
}

export interface TemplateKey {
  namespace: string;
  name: string;
}

export interface TemplateKeyAndCategory extends TemplateKey {
  category: string;
}

export interface TemplatesSummary {
  customer_specific: boolean;
  navigationPath: TemplateNavigationPath;
  key: TemplateKey;
  type: string;
  category: string;
  versions: string[];
  child_conditionals_enabled: string[] | null;
}

export interface TemplatesLevelData {
  options: string[];
  children: Record<string, any>;
}

export interface TemplatesFilter {
  hasDraftVersion: boolean;
  hasLiveVersion: boolean;
}

export interface CreationAndUpdateInfo {
  created_by: string;
  created_at: string;
  updated_by: string;
  updated_at: string;
  promoted_by: string | undefined;
  promoted_at: string | undefined;
  archived_by: string | undefined;
  archived_at: string | undefined;
}

export interface TemplateContent {
  body: string;
}

export interface TemplateConfig {
  extends_template: TemplateKey | null;
  overwrite_design: TemplateKey | null;
  parameters: Record<string, string> | null;
  show_content: string[] | null;
}

export interface Template {
  id: string;
  customer_specific: boolean;
  key: TemplateKey;
  version: string;
  type: TemplateType;
  category: string;

  config: TemplateConfig | undefined;
  content: TemplateContent | undefined;
  metadata: TemplateMetadata | undefined;

  creation_and_update_info: CreationAndUpdateInfo | undefined;
}

export interface TemplateMetadata {
  last_updated: string;
  extension_hierarchy: string[] | null;
  blocks_used: string[];
  macros_used: string[];
  translations_used: string[];
  content_structure: Record<string, any> | null;
}

export interface TemplateRenderReturn {
  template: Template;
  rendered_content: string;
  child_conditionals_in_parents: string[];
}

export interface TemplatePatchReturn extends TemplateRenderReturn {
  updated: string[];
}

export interface TemplatePutReturn extends TemplateRenderReturn {
  action: "created" | "updated";
}

export interface Translation {
  customer_specific: string;
  key: string;
  value: { [key: string]: string | null };
  version: string;
  creation_and_update_info: CreationAndUpdateInfo | undefined;
}

export interface TranslationsToUpdate {
  [key: string]: { [language: string]: string | null } | null;
}
